export const API_SERVICE = {
  STATION_HANDLER: 'station-handler',
  SFS: 'sfs-api'
}
